import { ArrowLeft, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { AddressTerminal } from "@/components/buy/AddressTerminal";
import { BuyBackdrop } from "@/components/buy/BuyBackdrop";
import { BuyPlatforms, BuySecurity, BuySteps } from "@/components/buy/BuyGuide";
import { BuyTokenInfo } from "@/components/buy/BuyTokenInfo";
import { BuyAnimatedIllustration } from "@/components/buy/BuyAnimatedIllustration";
import { MarketChart } from "@/components/market/MarketChart";
import { BUY_ANALYTICS_PLATFORMS, BUY_TRADING_PLATFORMS, BUY_WALLET_PLATFORMS, KBULL_TOKEN_ADDRESS, KBULL_ADDRESS_READY, KBULL_ADDRESS_VERIFIED } from "@/config/buy";
import "@/styles/buy-page.css";
import "@/styles/buy-navigation.css";

export default function BuyPage() {
  return (
    <div className="kb-buy-page" data-testid="get-kbull-page">
      <BuyBackdrop />
      <div className="buy-page-inner">
        <header className="buy-intro">
          <p className="buy-intro__eyebrow" data-testid="buy-page-eyebrow">KINGBULLISH / SOLANA</p>
          <h1 data-testid="buy-page-heading">GET <span>$KBULL</span></h1>
          <p className="buy-intro__subtitle" data-testid="buy-page-subtitle">BUY KINGBULLISH ON SOLANA</p>
          <p className="buy-intro__notice" data-testid="buy-page-address-warning"><ShieldCheck aria-hidden="true" /> Always verify the official contract address before buying.</p>
        </header>
        <AddressTerminal address={KBULL_TOKEN_ADDRESS} verified={KBULL_ADDRESS_VERIFIED} />
        <MarketChart placement="buy" />
        <BuySteps />
        <BuyPlatforms platforms={BUY_TRADING_PLATFORMS} title="TRADING PLATFORMS" sectionId="buy-trading-platforms" />
        <BuyPlatforms platforms={BUY_ANALYTICS_PLATFORMS} title="CHARTS & ANALYTICS" sectionId="buy-charts-analytics" />
        <BuyPlatforms platforms={BUY_WALLET_PLATFORMS} title="WALLET" sectionId="buy-wallet-platforms" />
        <BuyAnimatedIllustration />
        <div className="buy-details"><BuySecurity /><BuyTokenInfo address={KBULL_TOKEN_ADDRESS} ready={KBULL_ADDRESS_READY} /></div>
        <footer className="buy-page-footer" data-testid="buy-page-footer">
          <Link to="/" data-testid="buy-return-home"><ArrowLeft aria-hidden="true" /> KINGBULLISH HOME</Link>
          <span data-testid="buy-footer-verification">VERIFY THE ADDRESS. VERIFY THE NETWORK.</span>
        </footer>
      </div>
    </div>
  );
}